enum PaymentProvider {
    STRIPE = 'stripe',
}

export default PaymentProvider;
